// dotenv is not needed — CRA injects REACT_APP_* env vars at build time
const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://srp-services-local.smartserv.io';
const API_URLS = process.env.API_URLS || {
    LOCAL: "http://srp-services-local.smartserv.io",
    STAGE: "https://srp-services-stage.smartserv.io",
    UAT: "https://srp-services-uat.smartserv.io",
    DEMO: "https://srp-services-demo.zentrades.pro",
    PROD: "https://srp-services.zentrades.pro",
};
const FORM_KEYS = [
    "id",
    "isActive",
    "isDeleted",
    "companyId",
    "createdUserId",
    "updatedUserId",
    "createdAt",
    "updatedAt",
];
const SECTIONS_KEYS = [
    "id",
    "moduleEntityId",
    "moduleId",
    "companyId",
    "isActive",
    "isDeleted",
    "createdUserId",
    "updatedUserId",
    "createdAt",
    "updatedAt",
];
const FIELD_KEYS = [
    "id",
    "sectionId",
    "isActive",
    "isDeleted",
    "createdUserId",
    "updatedUserId",
    "createdAt",
    "updatedAt",
    "reasons",
];

const CURRENT_PLATFORM = process.env.CURRENT_PLATFORM || 'Prod';
const CROSS_PLATFORM = process.env.CROSS_PLATFORM || 'Demo';
const GOOGLE_KEYS = {
    CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID
};
const MASTER_COMPANY = process.env.REACT_APP_MASTER_COMPANY || '3';
const CUSTOMER_TYPE = {
    BILLING: 0,
    SERVICE: 1,
    COMMERCIAL: 2
};
const PATTERN = {
    0: '0',
    1: '1',
    2: '2',
    3: '3',
    4: '4'
};

const CSV_INGESTOR_BASE_URL = process.env.REACT_APP_CSV_INGESTOR_BASE_URL;

const SRP_USER_ROLES = {
    ADMIN: 'admin',
    DEVELOPER: 'developer',
    SUPPORT: 'support',
}

const MOVE_MODULE_CONSTANTS = {
    MODULES: {
        INDEPENDENT_INV_TO_DIFF_CUST: 'independentInv-to-diff-customer',
        INDEPENDENT_EST_TO_DIFF_CUST: 'independentEst-to-diff-customer',
        ESTIMATE_TO_DIFF_TICKET: 'estimate-to-diff-ticket'
    }
};

const FEATURES = {
    REGISTER_NEW_COMPANY: { label: "Register New Company", route: "register", icon: "Business" },
    EMAIL: { label: "Email", route: "email", icon: "Email" },
    REBUILD_ES_INDEX: { label: "Rebuild ES Index", route: "rebuildesindex", icon: "Build" },
    REBUILD_REDIS_CACHE: { label: "Rebuild Redis Cache", route: "rebuildrediscache", icon: "Cached" },
    TRIGGER_ANNOUNCEMENTS: { label: "Trigger Announcements", route: "triggerannoucements", icon: "Campaign" },
    BANNER_ANNOUNCEMENT: { label: "Banner Announcements", route: "banner-announcement", icon: "Announcement", isNew: true },
    MOVE: { label: "Move", route: "move", icon: "SwapHoriz" },
    DELETE: { label: "Delete", route: "delete", icon: "Delete" },
    QB_SYNC: { label: "QB Sync", route: "qbsync", icon: "Sync" },
    SETTINGS_UPDATE: { label: "Setting Update", route: "settings", icon: "Settings" },
    ONLINE_WEB_BOOKING: { label: "Online Web Booking", route: "featuresettings", icon: "Web" },
    FP_FORMS: { label: "FP Forms", route: "fpforms", icon: "Description" },
    RENEWAL_REMINDER_BANNER: { label: "Renewal Reminder Banner", route: "rrb", icon: "EventNote" },
    FEATURE_ENABLING: { label: "Feature Enabling", route: "feature/enable", icon: "ToggleOn" },
    FILE_UPLOAD: { label: "File Upload", route: "upload", icon: "UploadFile" },
    NOTIFICATION_PERMISSION: { label: "Notification Settings", route: "notification", icon: "Notifications" },
    USER: { label: "Srp Users", route: "user", icon: "PersonAddAlt" },
    ROLE: { label: "Roles", route: "role", icon: "Security" },
    PAYMENT_TERMS: { label: "Payment Terms", route: "paymentterms", icon: "AttachMoney" },
    ESTIMATE_REJECTION_REASON: { label: "Estimate Rejection Reasons", route: "estimate-rejection-reasons", icon: "Rule" },
    FORCE_LOGOUT: { label: "Force Logout", route: "forcelogout", icon: "ExitToApp" },
    CUSTOM_ASSIGNMENT_STATUS: { label: "Custom Assignment Status", route: "customassignmentstatus", icon: "AssignmentTurnedIn" },
};

module.exports = {
    BASE_URL,
    MASTER_COMPANY,
    GOOGLE_KEYS,
    CUSTOMER_TYPE,
    PATTERN,
    CURRENT_PLATFORM,
    CROSS_PLATFORM,
    API_URLS,
    FORM_KEYS,
    SECTIONS_KEYS,
    FIELD_KEYS,
    CSV_INGESTOR_BASE_URL,
    SRP_USER_ROLES,
    FEATURES,
    MOVE_MODULE_CONSTANTS
};
